// ==============================|| OVERRIDES - DIALOG CONTENT ||============================== //
// App-wide: MuiDialogContent-root uses padding-top spacing(4). Exception: when tabs are
// present (e.g. GroupPlanViewEditModal, MemberViewModal, MemberViewEditModal, GroupPlanViewModal),
// padding-top is spacing(2) via :has(.MuiTabs-root). No modal should override paddingTop locally.
//
// MUI default: when dividers=false, DialogContent uses selector .MuiDialogTitle-root + & and sets
// paddingTop: 0 (see node_modules/@mui/material/DialogContent/DialogContent.js). We override that
// below so our padding applies.

export default function DialogContent(theme) {
  return {
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: `${theme.spacing(4)} ${theme.spacing(4)} 0 ${theme.spacing(4)}`,
          // Override MUI's ".MuiDialogTitle-root + .MuiDialogContent-root { padding-top: 0 }"
          [`.MuiDialogTitle-root + &`]: {
            paddingTop: theme.spacing(4)
          },
          '&:has(.MuiTabs-root)': {
            paddingTop: theme.spacing(2)
          }
        }
      }
    }
  };
}
